var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhaseIcons04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 44,
    height: 44,
    rx: 22,
    stroke: "#CCD1E0",
    strokeWidth: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#001965"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6473 33.0034C22.0199 33.0027 21.4292 32.7078 21.0516 32.2067C20.674 31.7057 20.5533 31.0566 20.7255 30.4533L20.9836 29.5529C21.0355 29.3738 21.0617 29.1882 21.0616 29.0017C21.0616 27.8967 20.1658 27.0009 19.0608 27.0009H16.9969C15.8919 27.0009 14.9961 26.105 14.9961 25V23.9996C14.9961 23.9136 14.9961 23.8265 14.9961 23.7405C15.0638 21.3533 16.0772 19.0908 17.8133 17.4508C19.5493 15.8108 21.8658 14.9278 24.2529 14.9959C29.01 15.1742 32.8253 18.9895 33.0036 23.7465C33.0036 23.8325 33.0036 23.9186 33.0036 24.0046C33.0008 28.9753 28.9705 33.0034 23.9998 33.0034H22.6473Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0021 23.7217C28.8625 23.7223 28.7497 23.8358 28.75 23.9755C28.7504 24.1151 28.8638 24.2281 29.0035 24.2279C29.1431 24.2277 29.2562 24.1145 29.2562 23.9748C29.2565 23.9074 29.2298 23.8428 29.1821 23.7952C29.1343 23.7476 29.0695 23.7212 29.0021 23.7217",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0246 18.7467C23.922 18.7471 23.8299 18.8093 23.7912 18.9043C23.7525 18.9993 23.775 19.1082 23.8481 19.1801C23.9211 19.2521 24.0304 19.2728 24.1248 19.2326C24.2191 19.1924 24.2799 19.0993 24.2787 18.9968C24.279 18.9294 24.2522 18.8647 24.2045 18.8171C24.1568 18.7696 24.092 18.7431 24.0246 18.7437",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.507 20.1983C20.3675 20.1994 20.2552 20.3132 20.2559 20.4527C20.2566 20.5922 20.3701 20.7049 20.5097 20.7045C20.6492 20.7041 20.7621 20.5909 20.7621 20.4514C20.7624 20.3838 20.7355 20.319 20.6876 20.2714C20.6396 20.2238 20.5746 20.1975 20.507 20.1983",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5441 27.2393C27.4045 27.2399 27.2917 27.3534 27.292 27.4931C27.2924 27.6327 27.4058 27.7457 27.5455 27.7455C27.6851 27.7453 27.7982 27.6321 27.7982 27.4924C27.7988 27.4249 27.7721 27.3601 27.7243 27.3125C27.6765 27.2649 27.6116 27.2385 27.5441 27.2393",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5441 20.1983C27.4045 20.1988 27.2917 20.3124 27.292 20.4521C27.2924 20.5917 27.4058 20.7047 27.5455 20.7045C27.6851 20.7043 27.7982 20.591 27.7982 20.4514C27.7988 20.3839 27.7721 20.3191 27.7243 20.2715C27.6765 20.2239 27.6116 20.1975 27.5441 20.1983",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhaseIcons04);
export default __webpack_public_path__ + "static/media/Phase Icons 04.6f2d79371c9649b2dec748a82d18b4fe.svg";
export { ForwardRef as ReactComponent };